export default __webpack_public_path__ + "static/s3-3d54a81af6284b329d508903ddbb255c.webp";